import React from 'react';
import TopBusinessItem from './TopBusinessItem.jsx';
import {Businesses} from 'api';
import {withRouter} from 'react-router-dom';

class TopBusinessList extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      limit: 20,
      order: "id DESC"
    }
  }

  componentDidMount() {
    let params = {
      filter: {
        limit: this.state.limit,
        order: this.state.order
      }
    }
    Businesses.actions.listTopBusiness.request(params).then(response => {
      this.setState({
        data: response.data
      })
    });
  }

  render() {
    return (
      <div className='wrap-top-business'>
        <div className='top-business-list'>
          {
            this.state.data.map((item, i) => {
              return(
                <TopBusinessItem key={i} item={item}/>
              )
            })
          }
        </div>
      </div>
    );
  }
}

export default withRouter(TopBusinessList);



// WEBPACK FOOTER //
// ./components/home/sub-view/TopBusiness/TopBusinessList.jsx